<template>
    <el-drawer :visible.sync="innerVisible" :with-header="false" size="500px" direction="rtl" @close="handleClose">
        <div class="drawer-wrapper custom-wrapper">
            <el-form ref="customFormRef" :model="customForm" :rules="customRules" label-width="100px" size="small"
                @submit.native.prevent>
                <el-form-item label="商品ID" prop="sedkill_product_id">
                    <el-input :value="productId" placeholder="可填商城商品ID或自定义编号" disabled />
                </el-form-item>

                <el-form-item label="SKU 标题" prop="sedkill_sku_title">
                    <el-input v-model="customForm.sedkill_sku_title" placeholder="例如：黑色 M / 套装一" />
                </el-form-item>

                <!-- <el-form-item label="原价" prop="price">
                    <el-input v-model="customForm.price" placeholder="原价" type="number" disabled/>
                </el-form-item> -->

                <el-form-item label="直播价" prop="sedkill_price">
                    <el-input v-model="customForm.sedkill_price" placeholder="直播间秒杀价" type="number" />
                </el-form-item>

                <el-form-item label="库存" prop="stock">
                    <el-input v-model="customForm.stock" placeholder="库存数量" type="number" />
                </el-form-item>

                <el-form-item label="上架状态" prop="sell_status">
                    <el-radio-group v-model="customForm.sell_status">
                        <el-radio :label="1">上架</el-radio>
                        <el-radio :label="0">下架</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="封面图" prop="image">
                    <div class="image-uploader" @dragover.prevent @drop.prevent="onDropImage" @paste.stop="onPasteImage"
                        @click="triggerFileSelect">
                        <input ref="imageFileInput" type="file" accept="image/*" class="image-file-input"
                            @change="onFileChange" v-if="!customForm.image" />
                        <div v-if="customForm.image" class="image-preview">
                            <img :src="customForm.image" alt="" fit= />
                            <div class="image-actions">
                                <el-button type="text" size="mini" @click.stop="clearImage">
                                    重新上传
                                </el-button>
                            </div>
                        </div>
                        <div v-else class="image-placeholder">
                            <p>点击选择 / 拖拽图片到此处 / 粘贴截图</p>
                        </div>
                    </div>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="submitCustom">
                        保存并导入
                    </el-button>
                    <el-button @click="resetCustom">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
    </el-drawer>
</template>


<script>
// 按你 index.js 的写法，从总入口引入就行
import { uploadFile } from '@/api' // :contentReference[oaicite:1]{index=1}
import { captureCenterSquare, blobToFile } from '@/utils/liveSnapshot';
export default {
    name: 'miaopinDrawer',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        productId: {
            type: [String, Number],
            default: 0,
        },
        getLiveSourceEl: {
            type: Function,
            default: () => {
                return null
            }
        }
    },
    data() {
        return {
            innerVisible: false,
            // 自定义添加表单
            customForm: {
                sedkill_product_id: '',
                sedkill_sku_title: '',
                image: '',
                price: '',
                sedkill_price: '',
                stock: '',
                sell_status: 1
            },
            customRules: {
                // sedkill_product_id: [
                //     { required: true, message: '请输入商品ID', trigger: 'blur' }
                // ],
                sedkill_sku_title: [
                    { required: true, message: '请输入 SKU 标题', trigger: 'blur' }
                ],
                // price: [{ required: true, message: '请输入原价', trigger: 'blur' }],
                sedkill_price: [
                    { required: true, message: '请输入直播价', trigger: 'blur' }
                ],
                stock: [{ required: true, message: '请输入库存', trigger: 'blur' }],
                image: [{ required: true, message: '请上传封面图', trigger: 'change' }]
            },
        }
    },
    watch: {
        visible: {
            immediate: true,
            handler(val) {
                this.innerVisible = val
                // 抽屉打开时，如果还没有图，自动生成默认图
                if (!this.customForm.image && val) {
                    this.genDefaultImageIfPossible();
                }
            }
        },
        productId: {
            immediate: true,
            handler(val) {
                this.$set(this.customForm, 'sedkill_product_id', val)
            }
        }
    },
    async mounted() {
        document.addEventListener('paste', this.onGlobalPaste)

    },
    beforeDestroy() {
        document.removeEventListener('paste', this.onGlobalPaste)
    },
    methods: {
        async genDefaultImageIfPossible() {
            try {
                const sourceEl = this.getLiveSourceEl?.(); // 你来实现：优先拿截图复制功能的 canvas，其次 video
                console.log('sourceEl', sourceEl)
                if (!sourceEl) return;

                // 如果是 video，确保 ready
                if (sourceEl instanceof HTMLVideoElement && !sourceEl.videoWidth) {
                    await this.waitVideoReady(sourceEl, 1000);
                }

                const blob = await captureCenterSquare(sourceEl, 800);
                const file = blobToFile(blob, `miaopin_default_${Date.now()}.jpg`);

                // 复用你们现有上传方法（非常关键）
                await this.setSkuImageFromFile(file);
            } catch (e) {
                // 失败不阻断流程
                console.warn('[miaopin default image] failed:', e);
            }
        },
        async waitVideoReady(video, timeout = 1200) {
            const start = Date.now()
            while (Date.now() - start < timeout) {
                if (video.videoWidth > 0 && video.videoHeight > 0) return true
                await new Promise(r => setTimeout(r, 60))
            }
            return false
        },
        handleClose() {
            this.$emit('update:visible', false)
            this.$emit('close')
        },

        formatMoney(v) {
            const num = Number(v) || 0
            return num.toFixed(2)
        },
        /** 触发 input:file 选择图片 */
        triggerFileSelect() {
            const input = this.$refs.imageFileInput
            if (input) input.click()
        },

        onFileChange(e) {
            const file = e.target.files && e.target.files[0]
            if (file) {
                this.uploadImage(file)
            }
            e.target.value = ''
        },

        onDropImage(e) {
            const files = e.dataTransfer.files
            if (!files || !files.length) return
            const file = files[0]
            if (file && file.type && file.type.indexOf('image') === 0) {
                this.uploadImage(file)
            }
        },

        onGlobalPaste(e) {
            const file = this.extractImageFromClipboard(e)
            if (!file) return

            // 如果剪贴板里有图片，就拦截默认行为（不再往输入框里粘贴乱码）
            e.preventDefault()
            this.uploadImage(file)
        },

        /** 上传区域自身的 paste（保留也行，逻辑统一复用） */
        onPasteImage(e) {
            const file = this.extractImageFromClipboard(e)
            if (!file) return
            e.preventDefault()
            this.uploadImage(file)
        },

        /** 从剪贴板里尝试拿出一张图片 File，没有就返回 null */
        extractImageFromClipboard(e) {
            const clipboardData = e.clipboardData || window.clipboardData
            if (!clipboardData || !clipboardData.items) return null

            const items = clipboardData.items
            for (let i = 0; i < items.length; i++) {
                const item = items[i]
                if (item.type && item.type.indexOf('image') === 0) {
                    const file = item.getAsFile && item.getAsFile()
                    if (file) return file
                }
            }
            return null
        },

        clearImage() {
            this.customForm.image = ''
        },

        async uploadImage(file) {
            const formData = new FormData()
            formData.append('newfile', file)
            formData.append('mode', 'add')
            formData.append('currentpath', '/')
            try {
                const data = await uploadFile(formData)

                // 按之前 Node 接口返回的结构：{ code: 0, data: { url, key } }
                if (data.code !== 0 || !data.data || !data.data.url) {
                    this.$message.error(data.msg || '图片上传失败')
                    return
                }

                this.customForm.image = data.data.url

                // 触发表单校验
                if (this.$refs.customFormRef) {
                    this.$refs.customFormRef.validateField('image')
                }
            } catch (e) {
                console.error(e)
                this.$message.error('图片上传异常')
            }
        },


        resetCustom() {
            this.customForm = {
                sedkill_product_id: '',
                sedkill_sku_title: '',
                image: '',
                price: '',
                sedkill_price: '',
                stock: '',
                sell_status: 1
            }
            if (this.$refs.customFormRef) {
                this.$refs.customFormRef.clearValidate()
            }
        },

        submitCustom() {
            this.$refs.customFormRef.validate(valid => {
                // this.customForm.image = this.customForm.image || 'https://cfoss.wokfoy.com/testopen/00tAaWyNdTxV60EHimxrCplSo0S23UC8u9TNmo0x.jpg'
                if (!valid) return
                const p = Object.assign({}, this.customForm)
                // 类型转换一下
                p.price = Number(p.sedkill_price) || 0
                p.sedkill_price = Number(p.sedkill_price) || 0
                p.stock = Number(p.stock) || 0
                // 统一走和商城导入一样的事件：product 里已经是 create-sku 需要的字段
                this.$emit('select-sku', { product: p, isExport: false })

                this.$message.success('已添加到直播商品列表')
                this.resetCustom()
            })
        },
    }
}
</script>

<style scoped>
.drawer-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 20px;
}

.drawer-header {
    padding: 16px 16px 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.drawer-title {
    font-size: 16px;
    font-weight: 600;
}

.drawer-search {
    width: 280px;
}

.goods-table {
    flex: 1;
}

.drawer-footer {
    padding: 10px 16px;
    text-align: right;
}

/* 商品主信息 */
.goods-main {
    display: flex;
    align-items: center;
}

.goods-thumb {
    width: 48px;
    height: 48px;
    border-radius: 4px;
    object-fit: cover;
    margin-right: 8px;
}

.goods-info {
    overflow: hidden;
}

.goods-name {
    font-size: 13px;
    margin-bottom: 4px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.goods-tags .el-tag {
    margin-right: 4px;
}

/* SKU 区域 */
.sku-box {
    padding: 8px 0;
}

.sku-title {
    font-size: 13px;
    margin-bottom: 8px;
    font-weight: 500;
}

.sku-empty {
    padding: 12px 0;
    text-align: center;
    color: #999;
    font-size: 12px;
}

.image-uploader {
    width: 180px;
    height: 180px;
    border-width: 1px;
    border-style: dashed;
    border-color: rgb(217, 217, 217);
    border-image: initial;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.image-file-input {
    display: none;
}

.image-preview {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 6px;
}

.image-preview img {
    width: 180px;
    height: 180px;
    object-fit: cover;
}

.image-preview .image-actions {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 32px;
    text-align: center;
    background-color: rgba(255, 255, 255, 0.2);
}
</style>
